import PropTypes from "prop-types";
import { isNil } from "ramda";

import Presenter from "utils/PropTypesPresenter";
import StarringYouPresenter from "presenters/StarringYouPresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import CustomContentTypePresenter from "presenters/CustomContentTypePresenter";
import { appRoutes } from "routes";

const PRESENTERS = {
  algolia: StarringYouPresenter,
  templateGroup: TemplateGroupPresenter,
  morphablePackGroup: TemplateGroupPresenter,
  "custom-content-types": CustomContentTypePresenter,
};

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
  },
  {
    itemData(item) {
      return item?.data ? item.data : item;
    },
    itemValue(item) {
      return item?.attributes ? item.attributes : item;
    },
    normalize(item) {
      const itemData = this.itemData(item);

      return { ...this.itemValue(itemData), id: this.id(itemData), type: this.type(itemData) };
    },
    isFromAlgolia(item) {
      return !isNil(item?.objectID);
    },
    isTemplateGroup(item) {
      return this.type(item) === "templateGroup" || this.type(item) === "morphablePackGroup";
    },
    getPresenterTypeKey(item) {
      const itemData = this.itemData(item);

      if (this.isFromAlgolia(itemData)) return "algolia";

      return this.type(itemData);
    },
    delegateCall(item, methodName) {
      const presenter = PRESENTERS[this.getPresenterTypeKey(item)];

      return presenter && presenter[methodName]
        ? presenter[methodName](this.itemValue(this.itemData(item)))
        : undefined;
    },
    name(item) {
      return this.delegateCall(item, "name");
    },
    description(item) {
      return this.delegateCall(item, "description");
    },
    image(item) {
      return this.delegateCall(item, "posterUrl");
    },
    video(item) {
      return this.delegateCall(item, "previewVideo");
    },
    logo(item) {
      return this.delegateCall(item, "titleImage");
    },
    backgroundColor(item) {
      const itemData = this.itemData(item);
      if (this.isFromAlgolia(itemData) || this.isTemplateGroup(itemData)) return undefined;

      return CustomContentTypePresenter.backgroundColor(this.itemValue(itemData));
    },
    bottomBackgroundColor(item) {
      const itemData = this.itemData(item);
      if (this.isFromAlgolia(item) || this.isTemplateGroup(item)) return undefined;

      return CustomContentTypePresenter.backgroundGradientBottomColor(this.itemValue(itemData));
    },
    link(item) {
      const itemData = this.itemData(item);
      if (this.isFromAlgolia(itemData) || this.isTemplateGroup(itemData)) return this.linkForEcard(itemData);

      return CustomContentTypePresenter.link(this.itemValue(itemData));
    },
    linkForEcard(item) {
      const slug = this.id(item);

      if (TemplateGroupPresenter.isInvite(this.itemValue(item))) return appRoutes.invitesPreviewPath(slug);
      if (TemplateGroupPresenter.isStarringYouAI(this.itemValue(item))) return appRoutes.morphablePackGroupPath(slug);

      return appRoutes.templateGroupPath(slug);
    },
  },
);
